/**
 * Offers various scopes and sets background and defaults in foreign stores
 * created by herbert
 */

// the whole file is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

//window.console.log = function() {};

import React from 'react';
//import ReactDOM from 'react-dom';
//import Reflux from 'reflux';

import steleSVG from '../../SteleSVG.js';
import charging from './charging.jsx';
import * as config from '../../../../config.js';


/**
 * render charging station according to current parameters
 * @param{SteleCharging} chargingData		data object describing charging stations
 * @param{Function} storeChargingRect	function to call to store render objects ref
 * @param{Number} [steleRotation] 		global rotation of stele
 * @returns{?JSX} 						rendered charging or null if there's none
 */
export default function(chargingData, storeChargingRect, steleRotation, extraDoors) {
	const door = steleSVG.getPart(config.PART_DOOR_NAME, steleRotation%360);
	return (
		<div className="slx-stele-bottom">
			<img className="slx-stele__bottom__img"
				 src={steleSVG.getStele(3750, 0)} />
			<img className="slx-stele__door3" src={door} style={{display: extraDoors>=2 ? 'block': 'none'}} />
			<img className="slx-stele__door2" src={door} style={{display: extraDoors>=1 ? 'block': 'none'}} />
			<img className="slx-stele__door" src={door} />
			{charging(chargingData, storeChargingRect, steleRotation)}
		</div>
	);
}
